<template>
    <AppFormValidator
        ref="validator"
        #default="{ errors }"
        :model="model"
        :rules="rules">
        <CForm>
            <CInput
                v-model="model.title"
                label="Название"
                placeholder="Введите название"
                :is-valid="errors.title && errors.title.isValid" />

            <CInput
                v-model="model.code"
                label="Код"
                placeholder="Введите код"
                :is-valid="errors.code && errors.code.isValid" />
            <CInput v-model="computedCode" type="hidden" />

            <CInput
                v-model="model.legal_entity"
                label="Юр. лицо"
                placeholder="ООО…" />

            <CInput
                v-model="model.short_title"
                label="Короткое название"
                placeholder="Введите короткое название"
                :is-valid="errors.short_title && errors.short_title.isValid" />

            <CInput
                v-model="model.data_url"
                label="Ссылка YML каталога"
                :is-valid="errors.data_url && errors.data_url.isValid" />

            <CInput
                v-model="model.alias"
                label="Алиас"
                :is-valid="errors.alias && errors.alias.isValid" />
                
            <div class="flex items-center">
                <div class="flex items-center w-1/2">
                    <div class="col-form-label">Активен</div>

                    <CSwitch
                        class="ml-4"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.enabled" />
                </div>
                <div class="flex items-center w-1/2">
                    <div class="col-form-label">Архив</div>

                    <CSwitch
                        class="ml-4"
                        color="success"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="model.archive" />
                </div>
            </div>
        </CForm>

        <div class="flex mt-4">
            <CButton color="primary" @click="submit">{{ submitButtonTitle }}</CButton>

            <CButton
                v-if="model.id && adminOnly"
                variant="outline"
                color="danger"
                class="ml-4"
                @click="promptDelete">Удалить</CButton>
        </div>

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить запись? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </AppFormValidator>
</template>

<script>
    import to from 'await-to-js';
    import { morphism } from 'morphism';
    import { requiredRule, xssRegEx } from '@/utils/rules';

    import AppFormValidator from '@/components/AppFormValidator';
    import AppConfirmDialog from '@/components/AppConfirmDialog';
    import { translit } from '@/utils/translit';

    export default {
        components: {
            AppFormValidator,
            AppConfirmDialog,
        },

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            isPending: false,
            schedule: undefined,
            model: {},
            schema: {
                id: 'id',
                code: 'code',
                legal_entity: 'legal_entity',
                title: 'title',
                short_title: 'short_title',
                description: 'description',
                picture: 'picture',
                square_picture: 'square_picture',
                phone: 'phone',
                data_url: 'data_url',
                extended_schedule: 'extended_schedule',
                position: source => (source.position ? source.position : 1),
                enabled: source =>
                    typeof source.enabled === 'boolean' ? source.enabled : false,
                archive: source =>
                    typeof source.archive === 'boolean' ? source.archive : false,
            },
            rules: {
                title: [requiredRule],
                code: [requiredRule],
                description: [requiredRule],
            },
        }),

        computed: {
            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
            computedCode() {
                if (!this.entity.code) {
                    this.model.code = translit(
                        this.model.title ? this.model.title : ''
                    );
                }
                return this.model.code;
            },
        },

        created() {
            this.setModel();
        },

        methods: {
            setSchedule(schedule) {
                this.schedule = schedule;
            },
            setModel() {
                this.model = morphism(this.schema, this.entity);
                if (!this.entity.schedule) {
                    this.entity.schedule = [];
                }
                this.setSchedule(this.entity.schedule);
            },

            async submit() {
                const [error] = await to(this.$refs.validator.validate());

                if (error) {
                    return false;
                }

                const { id, ...payload } = this.model;

                payload.extended_schedule = !!payload.extended_schedule;
                payload.position = parseInt(payload.position);
                payload.data_url = payload.data_url ? payload.data_url : '';
                payload.schedule = this.schedule;

                if (typeof id === 'number') {
                    const [err] = await to(
                        this.axios.put(`/pharmacies/${id}`, payload)
                    );
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось сохранить запись.');
                    }
                } else {
                    const [err] = await to(this.axios.post('/pharmacies', payload));
                    if (err) {
                        return this.$root.$emit('showError', 'Ошибка. Не удалось создать новую запись.');
                    }
                }

                this.$emit('success');
            },

            promptDelete() {
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.model.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(`/pharmacies/${this.model.id}`)
                );

                if (error) {
                    this.$root.$emit('showError', 'Ошибка удаления.');
                }

                this.$emit('deleted');
            },
        },
    };
</script>
